export const CONDITIONS = {
  IS_NOT_SIGNED_IN: "is_not_signed_in",
  IS_RESEARCHER: "is_researcher",
  IS_SIGNED_IN: "is_signed_in",
  IS_STUDENT: "is_student",
};
